import React, { useEffect, useState } from 'react';
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable';

import SortableItem from 'presentation/pages/evaluation-schemes/elements/evaluation-formula/sortable-item';
import EvaluationFormulaElement from 'presentation/pages/evaluation-schemes/elements/evaluation-formula/formula-element';

export default function Sortable({ containerKey, elements, onRemove, handleDragEnd }) {
    const [items, setItems] = useState([elements]);

    useEffect(() => {
        setItems(elements);
    }, [elements]);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    return (
        <DndContext
            key={containerKey}
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <SortableContext
                items={items.map((e, i) => e.tokenId)}
                strategy={horizontalListSortingStrategy}
            >
                <ul className="evaluation-formula-container">
                    {items && items.map((e, i) => <SortableItem key={e.tokenId} id={e.tokenId} ><EvaluationFormulaElement tag={e.displayName} onRemove={() => onRemove(e.tokenId)} /></SortableItem>)}
                </ul>
            </SortableContext>
        </DndContext>
    );

}